import React, { Component } from "react";
import ScrollableAnchor, { configureAnchors, goToAnchor } from 'react-scrollable-anchor'
import Swipe from 'react-swipe-component';
import { push } from "../Services/Analytics"

import "./FlipPic.scss"

import FlipItems from "./FlipPic.items"
import FlipArrows from "./FlipPic.arrows"
import FlipBubbles from "./FlipPic.bubbles"

import dataJSON from "../../api/FlipPic.json"

class FlipPic extends Component {
  constructor(props) {
    super();
    this.state = {
      current: 0
    }
    this.switchFlip = this.switchFlip.bind(this);
    this.onSwipeLeftListener = this._onSwipeLeftListener.bind(this);
    this.onSwipeRightListener = this._onSwipeRightListener.bind(this);
    this.onSwipeDownListener = this._onSwipeUpListener.bind(this);
    this.onSwipeUpListener = this._onSwipeDownListener.bind(this);
    this.onSwipeListener = this._onSwipeListener.bind(this);
  }
  _onSwipeLeftListener() {
    push("Scroll_Swiped", "Left");
    this.switchFlip(Math.round(this.state.current - 1));
  }
  _onSwipeRightListener() {
    push("Scroll_Swiped", "Right");
    this.switchFlip(Math.round(this.state.current + 1));
  }
  _onSwipeUpListener() {

  }
  _onSwipeDownListener() {

  }
  _onSwipeListener(e) {
    window.scrollBy(0, e[1])
  }
  switchFlip(index) {
    index = (index < 0 ? dataJSON.list.length - 1 : index);
    index = (index > dataJSON.list.length - 1 ? 0 : index);
    this.setState({
      current: index
    })
  }
  componentDidMount() {
  }
  render() {
    return (
      <ScrollableAnchor id="tipflip">
        <section className="section section-flippic">
          <div className="padding">
            <div className="container">
              <div className="headline">
                <div className="head">
                  {dataJSON.headline}
                </div>
                <div className="desc" dangerouslySetInnerHTML={{ __html: dataJSON.desc }}></div>
              </div>
              <div className="flip">
                <Swipe
                  nodeName="div"
                  className="swipe-flip"
                  mouseSwipe={true}
                  onSwipedLeft={this.onSwipeLeftListener}
                  onSwipedRight={this.onSwipeRightListener}
                  onSwipedDown={this.onSwipeDownListener}
                  onSwipedUp={this.onSwipeUpListener}
                  onSwipe={this.onSwipeListener}>
                  <FlipItems current={this.state.current} />
                </Swipe>
                <FlipArrows switchFlip={this.switchFlip} current={this.state.current} />
                <FlipBubbles switchFlip={this.switchFlip} current={this.state.current} />
              </div>
            </div>
          </div>
        </section>
      </ScrollableAnchor>
    );
  }
}

export default FlipPic;


// WEBPACK FOOTER //
// ./src/Components/FlipPic/FlipPic.js